/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_NoInputs */



/**
* | output |
* | --- |
* | "No" |
*
* @param {Subtitle_Export_NoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_no = /** @type {((inputs?: Subtitle_Export_NoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_NoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Non")
	if (locale === "de") return /** @type {LocalizedString} */ ("NEIN")
	if (locale === "it") return /** @type {LocalizedString} */ ("NO")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Нет")
	if (locale === "es") return /** @type {LocalizedString} */ ("No")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("不")
	if (locale === "ja") return /** @type {LocalizedString} */ ("いいえ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नहीं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Não")
	return /** @type {LocalizedString} */ ("No")
});